import { Button, HStack, Spinner, VStack } from "@/shared/ui/primitives";

export interface CardHeaderProps {
	title: string;
	description: string;
	buttonLabel: string;
	onBtnTap?: () => void;
	isLoading?: boolean;
}

export const CardHeader = (p: CardHeaderProps) => {
	return (
		<HStack className="w-full items-center gap-[10px]">
			<VStack className="w-full gap-[2px]">
				<span className="w-full text-ct-strong text-lg font-medium">{p.title}</span>
				<span className="w-full text-ct-regular text-sm font-normal">{p.description}</span>
			</VStack>
			<Button onClick={p.onBtnTap} disabled={p.isLoading} className="shrink-0">
				{p.isLoading ? <Spinner size="sm" /> : p.buttonLabel}
			</Button>
		</HStack>
	);
};
